import { Navigate, Outlet } from 'react-router-dom';

import { IS_PROD } from '../constants/global-env';
import { routeConstant } from '../constants/routes';

export const DevRoute = () => {
  if (IS_PROD) {
    return <Navigate to={routeConstant.home} replace />;
  }

  return <Outlet />;
};
